export default "__VITE_ASSET__BbPnmTin__"